import { type ReactNode } from "react";

import "./appChrome.css";

function classNames(...values: Array<string | false | null | undefined>) {
  return values.filter(Boolean).join(" ");
}

export function AppChrome({
  className,
  title,
  headerActions,
  topBarStart,
  topBarEnd,
  children,
}: {
  className?: string;
  title?: ReactNode;
  headerActions?: ReactNode;
  topBarStart?: ReactNode;
  topBarEnd?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className={classNames("page-shell easy-app-shell", className)} aria-label={typeof title === "string" ? title : undefined}>
      {topBarStart || topBarEnd || headerActions ? (
        <header className="easy-app-topbar">
          <div className="easy-app-topbar-start">{topBarStart}</div>
          {headerActions || topBarEnd ? <div className="easy-app-topbar-end">{headerActions}{topBarEnd}</div> : null}
        </header>
      ) : null}
      {children}
    </section>
  );
}

export function AppSurface({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return <section className={classNames("easy-app-surface", className)}>{children}</section>;
}

export function AppActionBar({
  className,
  leading,
  trailing,
}: {
  className?: string;
  leading?: ReactNode;
  trailing?: ReactNode;
}) {
  if (!leading && !trailing) {
    return null;
  }

  return (
    <div className={classNames("easy-app-actionbar", className)}>
      <div className="easy-app-actionbar-leading">{leading}</div>
      <div className="easy-app-actionbar-trailing">{trailing}</div>
    </div>
  );
}

export function AppSecondaryBar({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return <div className={classNames("easy-app-secondarybar", className)}>{children}</div>;
}
